import { createAction, props } from '@ngrx/store';

const TAG = `[UI]`;

export const toggleSidebar = createAction(`${TAG} Toggle Sidebar`);
export const closeSidebar = createAction(`${TAG} Close Sidebar`);
export const openSidebar = createAction(`${TAG} Open Sidebar`);
